import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Address } from '@checkout/const';
import { DeliveryAddressService } from '@checkout/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { ModalService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { SdvorDeliveryAddressDialogModalComponent } from '../delivery-address-dialog/delivery-address-dialog-modal/delivery-address-dialog-modal.component';

@Component({
  selector: 'sd-delivery-address',
  templateUrl: './delivery-address.component.html',
  styleUrls: ['./delivery-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddressComponent implements OnInit {
  @Input() address: Address;
  iconType = CUSTOM_ICON_TYPE;

  active$: Observable<string>;

  constructor(
    protected modalService: ModalService,
    protected deliveryAddressService: DeliveryAddressService,
  ) {}

  ngOnInit(): void {
    this.active$ = this.deliveryAddressService.activeAddressId$;
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  deleteSavedAddress(): void {
    this.deliveryAddressService.deleteSavedAddress(this.address.id);
  }

  selectAddress(): void {
    this.deliveryAddressService.selectActiveAddressId(this.address.id);
  }

  editAddress(event: Event): void {
    this.stopPropagation(event);
    this.deliveryAddressService.editableAddressId$.next(this.address.id);

    this.modalService.open(SdvorDeliveryAddressDialogModalComponent, {
      centered: true,
      size: 'xl',
    });
  }
}
